var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import RouterService from "@ember/routing/router-service";
import Service, { service } from "@ember/service";
import SemeiaSessionService from "core/services/session";
let AnalyticsService = (_class = class AnalyticsService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
  }
  // This will configure Matomo analytics integration and start
  // the automatic route tracking. Every time the Ember router enters
  // a new route, an event is sent to Matomo.
  // The Matomo User ID is built as Medic_XXX or Patient_YYY.
  startRouterTracking() {
    const router = this.router;
    router.on("routeDidChange", () => {
      const page = router.currentURL;
      const title = router.currentRouteName || "unknown";
      const _paq = window._paq || [];
      _paq.push(["setCustomUrl", "/" + page]);
      _paq.push(["setDocumentTitle", title]);
      if (this.session.medic) {
        _paq.push(["setUserId", "Medic_" + this.session.medic.id]);
      } else if (this.session.patient) {
        _paq.push(["setUserId", "Patient_" + this.session.patient.id]);
      }
      _paq.push(["trackPageView"]);
    });
  }
  trackEvent(category, action, name, value) {
    const _paq = window._paq || [];
    _paq.push(["trackEvent", category, action, name, value]);
  }

  // When a Journal Event is created by the app, an event should be sent
  // to Matomo using this function. This is used mostly in forms' blockSave().
  trackJeCreation(je) {
    this.trackEvent("JournalEvent", "creation", je.constructor.type);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AnalyticsService as default };